import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { AuthCallback } from "@/components/AuthCallback";
import { MobileNav } from "@/components/MobileNav";
import { InstallPrompt, OfflineBanner } from "@/components/AppInstall";
import { AuthProvider } from "@/lib/auth";
import Home from "@/pages/Home";
import Library from "@/pages/Library";
import FaqDetail from "@/pages/FaqDetail";
import AskMechanic from "@/pages/AskMechanic";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/faqs" element={<Library />} />
      <Route path="/faq/:slug" element={<FaqDetail />} />
      <Route path="/ask" element={<AskMechanic />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Header />
          <OfflineBanner />
          <AppRouter />
          <Footer />
          <MobileNav />
          <InstallPrompt />
          <Toaster theme="dark" position="bottom-right" mobileOffset={{ bottom: "88px" }} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
